import {
    formatIncomeType,
    formatPayCycle,
    getIncomeOwnerOptionsMap,
} from '@fruitful/member-profile';
import { useMemo } from 'react';

import type { MembershipDetails } from '../../../entities/entityTypes';
import {
    MAIN_INCOME_TYPE_OPTIONS,
    MAIN_PAY_CYCLE_OPTIONS,
} from './moneyMapperIncomeForm';

export const useMoneyMapperIncomePickerItems = (
    membership: MembershipDetails | null,
) => {
    const ownerOptions = useMemo(
        () =>
            membership != null
                ? getIncomeOwnerOptionsMap(membership.users)
                : {},
        [membership],
    );

    const ownerPickerItems = useMemo(
        () =>
            Object.entries(ownerOptions).map(([label, value]) => ({
                label,
                value,
            })),
        [ownerOptions],
    );

    const payCyclePickerItems = useMemo(
        () =>
            MAIN_PAY_CYCLE_OPTIONS.map((cycle) => ({
                label: formatPayCycle(cycle),
                value: cycle,
            })),
        [],
    );

    const incomeTypePickerItems = useMemo(
        () =>
            MAIN_INCOME_TYPE_OPTIONS.map((incomeType) => ({
                label: formatIncomeType(incomeType),
                value: incomeType,
            })),
        [],
    );

    return {
        ownerOptions,
        ownerPickerItems,
        payCyclePickerItems,
        incomeTypePickerItems,
    };
};
